import {useMutation} from "@tanstack/react-query";
import {ApiError, AssetsApi, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {addError, decrementLoading, incrementLoading} from "@/redux/meta/metaActions";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";

interface UpdateProfilePictureParams {
    asset: Blob;
    name: string;
    description: string;
}

export function useUpdateProfilePicture() {
    const dispatch = useDispatch();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async (params: UpdateProfilePictureParams): Promise<void> => {
            dispatch(incrementLoading());
            try {
                const asset = await new AssetsApi(getConfig(fullToken)).createAssets(params);
                await new UsersApi(getConfig(fullToken)).updateUsersUpdateProfilePicture({
                    updateProfilePictureBody: {assetID: asset.id},
                });
            } finally {
                dispatch(decrementLoading());
            }
        },
        onError: async (e) => {
            dispatch(await addError(e as unknown as ApiError));
        },
    });
}
